// Tashkeel (Arabic diacritics) stripping. CLAUDE.md §3 / §13.
//
// Every Arabic text asset is authored with full Tashkeel; the renderer strips
// it down based on the learner's `tashkeel_mode`:
//   'with'    → leave every mark (default, educational baseline)
//   'partial' → keep shadda + the long-vowel-defining marks, drop short vowels
//   'without' → strip every harakat
//
// Pure + dependency-free so it can run in the Worker (admin preview) and the
// browser alike.

export type TashkeelMode = 'with' | 'partial' | 'without';

// Combining diacritic ranges:
//   U+064B–U+0652  tanwin + harakat + sukun + shadda
//   U+0670         superscript alef
//   U+0653–U+0655  madda / hamza-above / hamza-below
const ALL_MARKS = /[ً-ٰٕ]/g;

// "Short vowel" marks dropped in partial mode — fatha, damma, kasra, their
// tanwin forms, and sukun. Shadda (U+0651) + superscript alef are KEPT because
// they change the word, not just its vocalisation.
const SHORT_VOWEL_MARKS = /[ً-ِْ]/g;

export function stripTashkeel(text: string, mode: TashkeelMode): string {
  switch (mode) {
    case 'with':
      return text;
    case 'partial':
      return text.replace(SHORT_VOWEL_MARKS, '');
    case 'without':
      return text.replace(ALL_MARKS, '');
  }
}
